import { REFUND_API } from "@/services/Api/refundPirata";

export function useChargeMockPirata() {


    const solicitationRefund = (uuid: String, data: any) => {
        return REFUND_API.post(`?uuid=${uuid}`, data);
    }



    const verifyRefundBalance = (uuid: String) => {
        return REFUND_API.get(`?uuid=${uuid}`,);
    }




    return {
        solicitationRefund,
        verifyRefundBalance
    };
}
